<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div
                    class="d-flex align-items-center justify-content-between mb-4"
                >
                    <h1 class="h3 mb-3 text-gray-800">
                        {{ $t("Detalhes do Suporte") }} Protocolo:
                        <b> #{{ ticket.id }} </b>
                    </h1>

                    <div v-if="ticket.status_id">
                        <span v-if="ticket.status_id == 3">
                            <button
                                v-if="ticket.status_id"
                                class="btn btn-primary btn-resolvido"
                                data-style="zoom-in"
                                type="buttom"
                                @click.prevent="quickAction('status', 1)"
                            >
                                <i class="fas fa-check-circle"></i>
                                {{ $t("Reabrir") }}
                            </button>
                        </span>
                        <span v-else>
                            <button
                                v-if="ticket.status_id"
                                class="btn btn-success btn-resolvido"
                                data-style="zoom-in"
                                type="buttom"
                                @click.prevent="quickAction('status', 3)"
                            >
                                <i class="fas fa-check-circle"></i>
                                {{ $t("Marcar como resolvido") }}
                            </button>
                        </span>

                        <router-link
                            class="btn btn-default"
                            to="/dashboard/admin/suportes"
                        >
                            <i class="mdi mdi-arrow-left" />
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <b-card class="shadow">
            <loading-animation
                :active.sync="loading.form"
                :is-full-page="false"
                :opacity="1"
                color="#5895FF"
            />
            <div class="row">
                <div class="col-12">
                    <div
                        class="d-flex align-items-center justify-content-between mb-4"
                    >
                        <div>
                            <h4>{{ ticket.subject }}</h4>
                            <small class="text-sm pr-2">
                                <span :style="'color:' + ticket.status.color">{{
                                    ticket.status.name
                                }}</span>
                                -
                                {{
                                    ticket.created_at | momentFormatDateTimeAgo
                                }}
                            </small>
                        </div>
                        <div>
                            <button
                                class="btn btn-default"
                                data-style="zoom-in"
                                type="buttom"
                                @click="replyForm = true"
                            >
                                <i class="fas fa-reply"></i>
                                {{ $t("Responder") }}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12">
                    <loading-animation
                        :active.sync="loading.reply"
                        :is-full-page="false"
                        :opacity="1"
                        color="#5895FF"
                    />
                    <form @submit.prevent="addReply" style="width: 100%">
                        <div class="row" v-if="replyForm">
                            <div class="col-md-12">
                                <label
                                    class="block text-sm font-medium leading-5 text-gray-700"
                                    for="ticket_body"
                                    ><b
                                        >{{
                                            $t(
                                                "Tente ser o mais descritivo possível na sua resposta"
                                            )
                                        }}
                                        *</b
                                    ></label
                                >
                                <div class="mt-1 relative rounded-md">
                                    <input-wysiwyg
                                        id="ticket_body"
                                        v-model="ticketReply.body"
                                        :plugins="{
                                            images: true,
                                            attachment: true,
                                            shortCode: true,
                                        }"
                                        @selectUploadFile="selectUploadFile"
                                        :required="true"
                                    >
                                    </input-wysiwyg>
                                </div>
                                <div
                                    class="progress mt-3"
                                    style="height: 15px"
                                    v-if="uploadingFileProgress > 0"
                                >
                                    <div
                                        class="progress-bar"
                                        role="progressbar"
                                        :style="`width: ${uploadingFileProgress}%`"
                                        :aria-valuenow="uploadingFileProgress"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    >
                                        {{ uploadingFileProgress }}%
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="ticketReply.attachments.length > 0"
                                class="col-md-12 mt-2 px-0"
                            >
                                <div
                                    class="col-md-12"
                                    v-for="(
                                        attachment, index
                                    ) in ticketReply.attachments"
                                    :key="index"
                                >
                                    <attachment
                                        :details="attachment"
                                        v-on:remove="removeAttachment(index)"
                                        :key="index"
                                    />
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="float-right mt-3">
                                    <button
                                        class="btn btn-default"
                                        type="buttom"
                                        @click="discardReply"
                                    >
                                        <i class="fas fa-times"></i>
                                    </button>

                                    <button
                                        class="btn btn-success btn-submit"
                                        data-style="zoom-in"
                                        type="submit"
                                    >
                                        <i class="mdi mdi-content-save" />
                                        {{ $t("Enviar Resposta") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <input
                        ref="fileInput"
                        hidden
                        type="file"
                        @change="uploadFile($event)"
                    />
                </div>

                <div class="col-md-12">
                    <hr />
                    <div
                        class="col-md-12"
                        v-if="ticket.ticketReplies.length > 0"
                    >
                        <div
                            class="card border redound"
                            v-for="ticketReply in ticket.ticketReplies"
                            :key="ticketReply.id"
                        >
                            <div class="card-body p-3">
                                <span v-html="ticketReply.body"></span>

                                <div
                                    v-if="ticketReply.attachments.length > 0"
                                    class="col-md-12 mt-3 px-0"
                                >
                                    <hr />
                                    <div
                                        class="col-md-12"
                                        v-for="(
                                            attachment, index
                                        ) in ticketReply.attachments"
                                        :key="index"
                                    >
                                        <attachment
                                            :details="attachment"
                                            :remove-button="false"
                                            :key="index"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                :class="`${
                                    ticketReply.user.role_id != 3
                                        ? 'card-footer pb-0 border-top'
                                        : 'card-footer pb-0 bg-light'
                                }`"
                            >
                                <div class="media mb-2">
                                    <!-- <img
                    :alt="$t('Avatar')"
                    :src="
                      ticketReply.user.avatar !== 'gravatar'
                        ? ticketReply.user.avatar
                        : ticketReply.user.gravatar
                    "
                    class="rounded-circle img-fluid px-0 mr-3"
                    style="max-width: 40px; width: 100%"
                  /> -->
                                    <div class="media-body">
                                        <div class="row">
                                            <div class="col-12">
                                                <h5 class="float-left m-0">
                                                    <span
                                                        v-if="
                                                            ticketReply.user_remetente &&
                                                            ticketReply
                                                                .user_remetente
                                                                .nome_remetente !=
                                                                null
                                                        "
                                                    >
                                                        {{
                                                            ticketReply
                                                                .user_remetente
                                                                .nome_remetente
                                                        }}
                                                        -
                                                        {{
                                                            ticketReply.user
                                                                .name
                                                        }}
                                                    </span>
                                                    <span v-else>
                                                        {{
                                                            ticketReply.user
                                                                .name
                                                        }}
                                                    </span>
                                                </h5>
                                            </div>

                                            <div class="col-12">
                                                <span
                                                    v-if="
                                                        ticketReply.user_remetente &&
                                                        ticketReply
                                                            .user_remetente
                                                            .nome_remetente !=
                                                            null
                                                    "
                                                    >{{
                                                        ticketReply
                                                            .user_remetente
                                                            .unidade_remetente
                                                    }}
                                                    -
                                                </span>
                                                {{
                                                    ticketReply.created_at
                                                        | momentFormatDateTime
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-else>
                        <div class="h-full flex border-t">
                            <div class="m-auto">
                                <div
                                    class="grid grid-cols-1 justify-items-center h-full w-full py-24"
                                >
                                    <div
                                        class="flex justify-center items-center"
                                    >
                                        <svg-vue
                                            class="h-full h-auto w-48 mb-6"
                                            icon="undraw.task-list"
                                        ></svg-vue>
                                    </div>
                                    <div
                                        class="flex justify-center items-center"
                                    >
                                        <div
                                            class="w-full font-semibold text-2xl"
                                        >
                                            {{
                                                $t(
                                                    "Este Suporte ainda não tem interações!"
                                                )
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "Edit",
    metaInfo() {
        return {
            title: this.$i18n.t("Detalhes do Suporte"),
        };
    },
    filters: {
        momentFormatDateTime: function (value) {
            return moment(value)
                .locale("pt-BR")
                .format("L" + " HH:mm");
        },
        momentFormatDateTimeAgo: function (value) {
            return moment(value).locale("pt-BR").fromNow();
        },
    },
    mounted() {
        this.getTicket();
    },
    data() {
        return {
            replyForm: false,
            loading: {
                form: false,
                reply: false,
                file: false,
            },
            uploadingFileProgress: 0,
            ticket: {
                subject: null,
                department_id: null,
                body: "",
                attachments: [],
                user_remetente: {
                    id_remetente: null,
                    nome_remetente: null,
                    email_remetente: null,
                    funcao_remetente: null,
                    unidade_remetente: null,
                    unidade_id_remetente: null,
                    cidade_remetente: null,
                    estado_remetente: null,
                },
                ticketReplies: [],
                status_id: false,
                status: {
                    name: "",
                    cor: "",
                },
            },
            departmentList: [],
            ticketReply: {
                status_id: null,
                body: "",
                attachments: [],
                user_remetente: {
                    id_remetente: null,
                    nome_remetente: null,
                    email_remetente: null,
                    funcao_remetente: null,
                    unidade_remetente: null,
                    unidade_id_remetente: null,
                    cidade_remetente: null,
                    estado_remetente: null,
                },
            },
        };
    },
    methods: {
        discardReply() {
            this.ticketReply.body = "";
            this.ticketReply.attachments = [];
            this.replyForm = false;
        },
        addReply() {
            const self = this;
            self.loading.reply = true;

            const user = this.$store.state.user;

            this.ticketReply.user_remetente.id_remetente = user.id;
            this.ticketReply.user_remetente.nome_remetente = user.name;
            this.ticketReply.user_remetente.email_remetente = user.email;
            this.ticketReply.user_remetente.funcao_remetente =
                user.role_details.name;
            this.ticketReply.user_remetente.unidade_id_remetente =
                user.unidade.id;
            this.ticketReply.user_remetente.unidade_remetente =
                user.unidade.nome;
            this.ticketReply.user_remetente.cidade_remetente =
                this.$store.state.settings.app_cidade;
            this.ticketReply.user_remetente.estado_remetente =
                this.$store.state.settings.app_estado;

            axios
                .post(
                    this.$store.state.settings.app_suporte_url +
                        "api/tickets/" +
                        self.$route.params.uuid +
                        "/reply",
                    self.ticketReply,
                    {
                        headers: {
                            Authorization:
                                "Bearer " +
                                localStorage.getItem("token_suporte"),
                        },
                    }
                )
                .then(function (response) {
                    self.$snack.success({
                        button: false,
                        text: "Resposta cadastrada com sucesso!",
                    });

                    self.getTicket();
                    self.loading.reply = false;
                    self.replyForm = false;
                })
                .catch(function () {
                    self.loading.reply = false;
                });
        },
        quickAction(param, value) {
            const self = this;

            let ladda = Ladda.create(document.querySelector(".btn-resolvido"));
            ladda.start();
            axios
                .get(
                    this.$store.state.settings.app_suporte_url +
                        "api/tickets/setstatus",
                    {
                        headers: {
                            Authorization:
                                "Bearer " +
                                localStorage.getItem("token_suporte"),
                        },
                        params: {
                            uuid: self.$route.params.uuid,
                            action: param,
                            value: value,
                        },
                    }
                )
                .then(function (response) {
                    self.$snack.success({
                        button: false,
                        text: response.data.message,
                    });
                    ladda.stop();
                    self.getTicket();
                })
                .catch(() => ladda.stop());
        },
        getTicket() {
            const self = this;
            self.loading.form = true;
            axios
                .get(
                    this.$store.state.settings.app_suporte_url +
                        "api/tickets/" +
                        self.$route.params.uuid,
                    {
                        headers: {
                            Authorization:
                                "Bearer " +
                                localStorage.getItem("token_suporte"),
                        },
                    }
                )
                .then(function (response) {
                    self.loading.form = false;
                    self.ticket = response.data;
                })
                .catch(function () {
                    self.$router.push("/dashboard/admin/suportes");
                });
        },
        selectUploadFile() {
            if (!this.loading.file) {
                this.$refs.fileInput.click();
            } else {
                swal.fire(
                    "Error " + this.$i18n.t("Error").toString(),
                    this.$i18n.t("A file is being uploaded").toString(),
                    "warning"
                );
            }
        },
        uploadFile(e) {
            const self = this;
            const formData = new FormData();
            self.loading.file = true;
            formData.append("file", e.target.files[0]);
            axios
                .post(
                    this.$store.state.settings.app_suporte_url +
                        "api/tickets/attachments",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization:
                                "Bearer " +
                                localStorage.getItem("token_suporte"),
                        },
                        onUploadProgress: function (progressEvent) {
                            self.uploadingFileProgress = Math.round(
                                (progressEvent.loaded / progressEvent.total) *
                                    100
                            );
                        }.bind(this),
                    }
                )
                .then(function (response) {
                    self.loading.file = false;
                    self.uploadingFileProgress = 0;
                    self.$refs.fileInput.value = null;
                    self.ticketReply.attachments.push(response.data);
                })
                .catch(function () {
                    self.loading.file = false;
                    self.uploadingFileProgress = 0;
                    self.$refs.fileInput.value = null;
                });
        },
        removeAttachment(attachment) {
            this.ticketReply.attachments.splice(attachment, 1);
        },
    },
};
</script>

<style>
.relative {
    position: relative;
    z-index: 1;
}
</style>
